<template>
    <div class="upload-out">

     <div class="upload-main">
        <van-form @failed="onFailed" ref="form">
        <van-cell-group inset>
        <div class="upload-container">
            
          <div class="common upload-top">
              
              <p class="top-title">馆藏著录</p>
                <div class="form-item">
                    <p class="common-title">题名<span class="common-red">*</span></p>
                    <p class="maxlength">{{form.collectionName.length}}/{{maxlength}}</p>
                    <van-field
                       style="height:auto;padding:0.1704rem;"
                        v-model="form.collectionName"
                        rows="2"
                        autosize
                        type="textarea"
                        :maxlength="maxlength"
                        placeholder=""
                        :rules="[{ required: true, message: '请填写题名' }]"
                    />
                    <span class="common-bottom_title">请概括填写本馆藏的内容标题，最多50字</span>
                </div>
                <span class="line"></span>
                 <div class="form-item">
                    <p class="common-title">馆藏责任者<span class="common-red">*</span></p>
                    <p class="maxlength">{{form.responsibleOfficer.length}}/{{maxlength}}</p>
                    <van-field
                        style="height:auto;padding:0.1704rem;box-sizing: border-box"
                        v-model="form.responsibleOfficer"
                        rows="1"
                        autosize
                        type="textarea"
                        :maxlength="maxlength"
                        :rules="[{ required: true, message: '请填写馆藏责任者' }]"
                    />
                    <span class="common-bottom_title">创建馆藏内容的主要责任者</span>
                </div> 
                <span class="line"></span> 
                  <div class="form-item">
                    <p class="common-title">馆藏责任者责任方式<span class="common-red">*</span></p>
                    <p class="maxlength">{{form.responsibleMethod.length}}/{{maxlength}}</p>
                    <van-field
                        style="height:auto;padding:0.1704rem;box-sizing: border-box"
                        v-model="form.responsibleMethod"
                        rows="1"
                        autosize
                        type="textarea"
                        :maxlength="maxlength"
                        :rules="[{ required: true, message: '请填写馆藏责任者责任方式' }]"
                    />
                    <span class="common-bottom_title">创建馆藏内容的主要责任者</span>
                </div> 
                <span class="line"></span> 
                <div class="form-item">
                    <p class="common-title">馆藏分类<span class="common-red">*</span></p>
                    <van-field
                        readonly
                        clickable
                        :value="pickerForm.cateId"
                        placeholder=""
                        @click="isCategoryTree = true"
                    />
                    <van-popup v-model="isCategoryTree" round position="bottom">
                    <van-picker
                        show-toolbar
                        value-key="cateName"
                        :columns="categoryTree"
                        @cancel="isCategoryTree = false"
                        @confirm="onCateConfirm"
                    />
                    </van-popup>
                    <span class="common-bottom_title">馆藏所属分类</span>
                    <span v-if="!pickerForm.cateId&&pickerTest" class="common-bottom_title test-text" style="color:red;">请选择馆藏分类</span>
                    <img class="common_icon" src="@/images/more.png" alt="">
                </div>
                <span class="line"></span>
                <div class="form-item">
                    <p class="common-title">关联专题</p>
                    <van-field
                    readonly
                    clickable
                    :value="pickerForm.topicId"
                    placeholder=""
                    @click="isTopicPicker = true"
                    />
                    <van-popup v-model="isTopicPicker" round position="bottom">
                    <van-picker
                        show-toolbar
                        value-key="topicName"
                        :columns="topicTree"
                        @cancel="isTopicPicker = false"
                        @confirm="onTopicConfirm"
                    />
                    </van-popup>
                    <span class="common-bottom_title">馆藏所属专题</span>
                    <img class="common_icon" src="@/images/more.png" alt="">
                </div>
                <span class="line"></span>
                <div class="form-item">
                    <p class="common-title">版权拥有者<span class="common-red">*</span></p>
                    <van-field
                        readonly
                        clickable
                        :value="pickerForm.copyrightOwner"
                        placeholder=""
                        @click="isOwnerPicker = true"
                    />
                    <van-popup v-model="isOwnerPicker" round position="bottom">
                    <van-picker
                        show-toolbar
                        value-key="dictValue"
                        :columns="copyrightOptions"
                        @cancel="isOwnerPicker = false"
                        @confirm="onOwnerConfirms"
                        
                    />
                    </van-popup>
                    <span class="common-bottom_title">创建馆藏内容的主要责任者</span>
                    <span v-if="!pickerForm.copyrightOwner&&ownerPickerTest" class="common-bottom_title test-text" style="color:red;">请选择版权拥有者</span>
                    <img class="common_icon" src="@/images/more.png" alt="">
                </div>
                <span class="line"  v-if="form.copyrightOwnerType===2"></span>
                <div v-if="form.copyrightOwnerType===2">
                    <div class="form-item" >
                    <p class="common-title">数据库厂商名称<span class="common-red">*</span></p>
                     <van-field
                        style="height:auto;padding:0.3704rem;"
                        v-model="form.copyrightOwner"
                        rows="2"
                        autosize
                        placeholder=""
                        :rules="[{ required: true, message: '请填写数据库厂商名称' }]"
                    />
                    </div>
                    <span class="line" ></span>
                    <div class="form-item">
                        <p class="common-title">版权结束日期<span class="common-red">*</span></p>
                        <van-field
                        readonly
                        clickable
                        :value="form.copyrightExpiresTime"
                        placeholder=""
                        @click="isDateShow = true"
                        />
                        <van-calendar v-model="isDateShow"   @cancel="isDateShow = false" @confirm="onDateConfirm" />
                        <img style="margin-top: 0;" class="common_icon" src="@/images/more.png" alt="">
                    </div>
                </div>
                <span class="line"  v-if="form.copyrightOwnerType===3"></span>
                <div v-if="form.copyrightOwnerType===3">
                    <div class="form-item" >
                    <p class="common-title">网站名<span class="common-red">*</span></p>
                     <van-field
                        style="height:auto;padding:0.3704rem;"
                        v-model="form.copyrightOwner"
                        rows="2"
                        autosize
                        placeholder=""
                        :rules="[{ required: true, message: '请填写网站名' }]"
                    />
                    </div>
                </div>
             <span class="line"  v-if="isShowMore"></span>
              <div class="form-item" v-if="isShowMore">
                    <p class="common-title">馆藏描述<span class="common-red">*</span></p>
                    <p class="maxlength">{{form.description.length}}/{{descriptionMaxlength}}</p>
                    <van-field
                       style="height:auto;padding:0.3704rem;"
                        v-model="form.description"
                        rows="3"
                        autosize
                        type="textarea"
                        :maxlength="descriptionMaxlength"
                        placeholder=""
                        :rules="[{ required: true, message: '请填写馆藏描述' }]"
                    />
                    <span class="common-bottom_title">对馆藏内容相关的描述说明、附注等</span>
                </div>
            <!-- <div class="more" @click="showMore">
                <span class="" >{{showMoreText}}</span>
              </div> -->
          </div>
          <div class="common upload-bottom">
              <p class="bottom-title">资源著录</p>
              <div class="bottom-list">
                  <span>文件</span>
                  <span>操作</span>
              </div>
            <div class="upload-list" v-for="(item,index) in form.resources" :key="index">
                <div class="upload-list_left"> 
                   <img v-if="item.resourceType=='image'" src="@/assets/img.png" alt="404">
                    <img v-if="item.resourceType=='pdf'" src="@/assets/pdf.png" alt="404">
                    <img v-if="item.resourceType=='video'" src="@/assets/video.png" alt="404">
                    <img v-if="item.resourceType=='audio'" src="@/assets/rec.png" alt="404">
                    <img v-if="item.resourceType=='zip'" src="@/assets/zip.png" alt="404">
                    <span class="file-name">{{item.resourceFileName}}</span>
                </div>
                <div class="upload-list_right">
                    <van-button class="set-page_common set-page_btn"  type="default" v-if="previewId==item.id" @click="cancelPreview(item)">取消封面</van-button>
                    <van-button class="set-page_common set-page_btn"  type="default" v-else @click="setPage(item)">设为封面</van-button>
                    <van-button class="set-page_common" type="default" @click="deleteRow(item)">删除</van-button>
                </div>

            </div>
          </div>
        </div>
        </van-cell-group>
        <div class="upload-btn">
          <div class="check-btn" @click="cataloging">
              <span>下一步</span><span class="dot"> . </span><span>提交审核</span>
          </div>
        </div>
        </van-form>
     </div>
     <div class="naviPosition" />
     <div class="digNavigate">
       <router-link class="navItm" :to="{ name: 'Waphome' }">
         <img src="../../../images/home.png" class="img-normal">
         <img src="../../../images/home_select.png" class="img-active">
         <label>首页</label>
       </router-link>
       <router-link class="navItm" :to="{ name: 'Waplist' }">
         <img src="../../../images/res.png" class="img-normal">
         <img src="../../../images/res_select.png" class="img-active">
          <label>{{clients.collectionTheme?clients.collectionTheme:'特藏'}}</label>
       </router-link>
       <router-link class="navItm active" :to="{ name: 'Wapcertified' }">
         <img src="../../../images/upload.jpg" class="img-normal">
         <img src="../../../images/upload_select.jpg" class="img-active">
         <label>上传</label>
       </router-link>
       <router-link class="navItm" :to="{ name: 'Wapuser' }">
         <img src="../../../images/use.png" class="img-normal">
         <img src="../../../images/use_select.png" class="img-active">
         <label>我的</label>
       </router-link>
     </div>
     <!-- <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar title="请选择分类" :columns="columns" :confirm-button-text="confirmText"  :cancel-button-text='cancelText'   @cancel="showPicker = false" @confirm="onConfirm"/> -->
    <!-- </van-popup>   --> 
    <!-- <van-field
      readonly
      clickable
      label="城市"
      :value="value"
      placeholder="选择城市"
      @click="showPicker = true"
      /> -->
    <!-- <van-popup v-model="showPicker" round position="bottom"> -->
    </div>
 </template>
 <script>
// import { Picker } from 'vant'
import { Dialog,Toast } from 'vant';
import {
  collectionResource,
  removeResourse,
  inputReferParse,
  cataloging,
  regionlistByName
} from '@/api/library'
import {
  getTopicTree,
  getRegiontree,
  getGenreTree,
  getCategoryTree,
  getSubjectTree,
  getTenantList,
  getDictList
} from '@/api/publish'
import api from '../../../api/home.js'
 export default {
    data() {
      return {
        maxlength:'50',
        isCategoryTree:false,
        isTopicPicker:false,
        isOwnerPicker:false,
        isDateShow:false,
        showMoreText:'填写更多',
        isShowMore:true,
        pickerTest:false,
        pickerForm:{
            cateId:''
        },
        previewId:'',
        form: {
            id: 0,
            collectionName: '',
            subtitle: '',
            chapterOrder: '',
            chapter: '',
            cateId: '',
            subjectId: '',
            topicId: '',
            responsibleOfficer: '',
            responsibleMethod: '',
            otherResponsibleOfficer: '',
            otherResponsibleMethod: '',
            publications: '',
            publisher: '',
            publishArea: '',
            publishTime: '',
            publicationsType: '',
            publicationsCode: '',
            copyrightOwner: '',
            copyrightOwnerType: '',
            collectionLevel: '',
            copyrightExpiresTime: '',
            transWeb: '',
            ageRange: '',
            collectionInfo: '',
            description: '',
            preview: '',
            keyword: '',
            chronicleDate: '',
            areaAffected: '',
            areaAffectedName: '',
            personAffected: '',
            resources: []
        },
        regiontree: [], // 行政区域树.
        genretree: [], // 体裁分类树
        categoryTree: [], // 分类树
        topicTree: [], // 专题
        subjectTree: [], // 学科树
        copyrightOptions:[],//版权拥有者树
        tenantIdOptions:[],//版权拥有者分类树
        ruleForm: {
            titleName: '',
            collectionOwner:'',
            collectionClassify:'',
            relatedTopics:'',
            copyrightOwner:'',
            vendorName:'',
            endDate:'',
        },
         value: '123',
         message:'',
      showPicker: false,
      columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
        activeId: '',
        activeIndex: '',
        value: '',
        showPicker: false,
      confirmText: '确定',
      cancelText:'X',
      pickerTest:false,
      ownerPickerTest:false,
      descriptionMaxlength:1000,
      clients:{}
      };
    },
    mounted() {
        
        this.requestTrees()
        this.collectionResource()
    },
    created(){
        this.requestclient();
    },
    methods: {
        //获取应用信息
        requestclient() {
            const that = this;
            api
            .requestclient({ tenantId: this.$store.getters.tenantId })
            .then(r => {
                that.clients = r.data;
            })
            .catch(err => {
                console.log(err);
            });
        },
        // pickertest(){
        //     if(!pickerForm.cateId){
        //         return false
        //     }
        // },
       async onSubmit(){
            let dataForm  = this.form;
            this.form.resources.forEach((element, index) => {
            var item = {}
            for (const key in element) {
                if (key === 'genre') {
                    item[key] = element[key] === '' ? '' : element[key][element[key].length - 1]
                } else if (key === 'sort') {
                    item[key] = index + 1
                } else if (key === 'personAffected') {
                    item[key] = element[key].toString()
                } else {
                    item[key] = element[key]
                }
            }
            console.log(JSON.stringify(item))
            dataForm.resources.push(item)
            })
            dataForm.status = 6;
            const res = await cataloging({
                collectionVOs: [dataForm],
                tenantId: this.$store.getters.tenantId
            })
            if(res.data){
                this.form.resources = [];
                this.$router.push({
                    path:'/wap/descriptioncheck',
                    query:{
                        collectionId:this.$route.query.collectionId
                    }
                })
            }
        },
        onFailed(error){
            console.log('error',error)
        },
        async cataloging(){
            console.log('this.form',this.form)
            this.$refs['form'].validate().then(()=>{
                if(!this.form.preview){
                   return Toast.fail('请设置封面');
                }
                if(this.form.cateId&&this.form.copyrightOwner){
                    this.onSubmit();
                }
            }).catch(()=>{
                console.log('请填写必填项')
            })
            if(!this.pickerForm.cateId){
                 this.pickerTest = true;
            }
            if(!this.pickerForm.copyrightOwner){
                 this.ownerPickerTest = true;
            }
            // if(!this.form.description||!this.form.copyrightOwner||!this.form.cateId||!this.form.collectionName||!this.form.responsibleOfficer||!this.form.responsibleMethod){
            //         return Toast.fail('请检查必填项')
            // }
           
            
        },
         async deleteRow(item) {
            Dialog.confirm({
                title: '提示',
                message: '是否删除该条资源！删除后无法找回',
            })
            .then(() => {
                this.removeResourse(item)
            })
            .catch(() => {
                // on cancel
            });
           
        },
        //删除封面
        async removeResourse(item) {
            const res = await removeResourse({
                ids: item.id
            })
            if (res.data) {
                this.collectionResource();
            }
        },
        //取消封面
        cancelPreview(){
            this.form.preview = '';
            this.previewId = '';
        },
        //设置封面
        setPage(item){
            if (item.resourceType === 'video') {
                this.form.preview = item.previewUrl;
            } else if (item.resourceType === 'image') {
                this.form.preview = item.resourceCloudUrl
            }
            this.previewId = item.id;

           console.log('item',item) 
        },
        //填写更多
        showMore(){
            this.isShowMore = !this.isShowMore;
            this.isShowMore?this.showMoreText='收起':this.showMoreText='填写更多' 
            
            
        },
        async collectionResource() {
            this.loading = true
            const res = await collectionResource({
                ids: this.$route.query.collectionId
            })
            this.loading = false
            this.form.id = res.data[0].id
            res.data[0].resources.forEach(element => {
                element.langue = ''
                element.subtitlesLangue = ''
                element.videoAndAudioLangue = ''
            })
            this.form.resources = res.data[0].resources
        },
        //日期选择器
        formatDate(date) {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        onDateConfirm(date){
            this.isDateShow = false;
            this.form.copyrightExpiresTime = this.formatDate(date);
            console.log('val',date)

        },
        tenantIdFormat(cellValue) {
        if (cellValue != null && cellValue !== '') {
            const item = this.tenantIdOptions.find(item => {
            return cellValue === item.tenantId
            })
            if (item) {
            return item.tenantName
            }
        }
        return ''
        },
        onOwnerConfirms(val){
        this.form.copyrightOwner=''
        this.form.copyrightOwnerType = val.dictKey;
        if (val.dictKey === 1) {
            this.form.copyrightOwner =this.tenantIdFormat(this.$store.getters.tenantId)
            this.pickerForm.copyrightOwner =val.dictValue+'/'+this.tenantIdFormat(this.$store.getters.tenantId)
        }else{
            this.pickerForm.copyrightOwner =val.dictValue
        }
        this.isOwnerPicker = false;
        this.ownerPickerTest = false;
            console.log('val',val)
        },
        //关联专题picker
        onTopicConfirm(val){
            this.form.topicId = val.id;
            this.pickerForm.topicId = val.topicName
            this.isTopicPicker = false;
            console.log('val',val)
        },
        onChange(picker, values){
            console.log('picker',picker,'values',values)
        },
        //馆藏分类picker
        onCateConfirm(data,index){
            let vm = this;
            let str = "";  // 呈现页面显示  /xxx/xxx/xxx
                for(let i = 0;i < data.length; i ++){
                    if(i>0){
                        str += "/" + data[i];
                    }
                    else{
                        str +=data[i];
                    }
                }
        vm.form.cateId =vm.categoryTree[index[0]].children[index[1]].id;
        vm.pickerForm.cateId = str;
        console.log('vm.form.cateId',vm.form.cateId)
        console.log('vall',data,index)
        this.isCategoryTree = false
        this.pickerTest = false;
        },
        //专题tree
        async getTopicTree() {
        const res = await getTopicTree({
            tenantId: this.$store.getters.tenantId//'ADKS'
        })
        this.topicTree = res.data
        },
        async getDictList() {
        const res = await getDictList()
        console.log(res)
        res.data.forEach(element => {
            if (element.code === 'copyright_owner') {
            this.copyrightOptions = element.children
            } else if (element.code === 'publication_logo') {
            this.publicationOptions = element.children
            } else if (element.code === 'collection_level') {
            this.collectionleverOptions = element.children
            } else if (element.code === 'typical_age_range') {
            this.typicalagerangeOptions = element.children
            } else if (element.code === 'langue') {
            console.log(element.children)
            this.langueOptions = element.children
            }
        })
        },
        //初始化选择器数据
        requestTrees() {
            const that = this
            getCategoryTree({ tenantId: this.$store.getters.tenantId }).then(r => {
                that.categoryTree = r.data
            })
            getTenantList().then(r => {
                that.tenantIdOptions = r.data
            })
            getSubjectTree().then(r => {
                that.subjectTree = r.data
            })
            this.getTopicTree()
            this.getDictList()
            getGenreTree().then(r => {
                r.data.forEach(element => {
                element.disabled = true
                })
                that.genretree = r.data
            })
            getRegiontree().then(r => {
                that.regiontree = r.data
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                alert('submit!');
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
 }
 </script>
 <style src="@/styles/wap.scss" lang="scss" scoped></style>
 <style scoped lang="scss">
    .test-text{
        position:absolute;
        top:30px;
        left:10px;
    }
    .maxlength{
        position: absolute;
        top:0;
        right:0;
        font-size: 0.3333rem;
        font-weight: 400;
        color: rgba(123, 132, 161, .5);
    }
    .set-page_btn{
        margin-right:0.5278rem;
    }
    .set-page_common{
        border: none;
        padding:0;
        height: 30px;
        font-size: 0.3333rem;
        font-weight: 400;
        color: #7B84A1;
    }
    .upload-list{
        width: 100%;
        font-size: 0.2407rem;
        display:flex;
        justify-content:space-between;
        height:0.8333rem;
        .file-name{
                width: 4.25rem;
                display:inline-block;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            
        }
        .upload-list_left{
            line-height: 0.5556rem;
                display:flex;
                align-items: center;
        }
            .upload-list_right{
                line-height: 0.5556rem;
                display:flex;
                align-items: center;
                margin-right: 0.6852rem;
        } 
        .common-img{
            width:0.5926rem;
            height:0.5926rem;
            display: inline-block;
        }
    }
    .form-item{
        position: relative;
    }
    .common_icon{
        width: 0.5926rem;
        height: 0.5926rem;
        position: absolute;
        right:0;
        top: 50%;
        margin-top: -0.2063rem;
        display: inline-block;
    }
    .van-overlay{
        background-color:rgba(0,0,0,.3);
    }
    .line{
        height: 1px;
        background: #F3F4F9;
        display: inline-block;
        width:100%;
        margin:0.463rem 0;
    }
    .common-bottom_title{
      font-size: 0.3333rem;
      font-weight: 400;
      color: #7B84A1;
      line-height: 0.2778rem;
      margin-top: 0.2593rem;
      display: inline-block;
    }
    
    .common-red{

    color: #FA5E5F;
    }
    .common-title{
      font-size: 0.3889rem;
      font-weight: 400;
      color: #1F233E;
      padding-bottom: 0.2778rem;
      
    }
    .upload-out {
        height: 100%;
    }
    .van-field{
      height: 0.9259rem;
      border: 1px solid #DEE0E7;
    }
    ::v-deep .van-field__body{
       height: 0.9259rem;
    }
    .van-field__control{
      border:none;
    }
    /* .relative{
      position: relative;
    }
    .absolute{
      position: absolute;
    } */
    /* .upload-main {
      bottom: 1.25rem;
    } */
     .upload-container {  
         box-sizing: border-box;
         width: 100%;
         padding: 0.3704rem 0.3333rem 0.3241rem 0.3333rem;
         background: #eee;
     }
     .common {
         width: 100%;
         background: #FFFFFF;
         box-shadow: 0px 0.0463rem 0.1389rem 0px rgba(0,0,0,0.05);
         border-radius: 0.1111rem;
     }
     .upload-top {
         box-sizing: border-box;
         margin-bottom: 0.2778rem;
         padding:0.3704rem;

     }
     .top-title{
        width: 100%;
        margin-bottom: 0.4259rem;
        font-size: 0.4444rem;
        font-weight: 700;
        color: #4C70E8;
     }
     .titleName {
        height: 1.5741rem;
        /* padding: 0.3704rem 0.3519rem 0.3704rem 0.3519rem */
     }
     .more{
      border: 1px solid #DEE0E7;
      border-radius: 0.1111rem;
      height: 0.9259rem;
      line-height: 0.9259rem;
      text-align: center;
      font-size: 0.3333rem;
      color: #7B84A1;
      margin-top: 0.3704rem;
     }
     .explanation{
        height: 0.8333rem;
        font-size: 0.3333rem;
        color: #7B84A1;
        line-height: 0.8333rem;
        margin-bottom: 0.2222rem;
     }
     
     .img-submit {
        height: 1.4444rem;
        margin-top: 1.8148rem;
        margin-left: 3.9444rem;
     }
     .upload-bottom {
         box-sizing: border-box;
         height: 5.037rem;
         padding-left: 0.3704rem;
         padding-top: 0.3704rem;
         padding-right: 0.3704rem;
     }
     .bottom-title {
         height: 0.4259rem;
         font-size: 0.4444rem;
         font-weight: 700;
         color: #4C70E8;
     }
     .bottom-list {
         margin-top: 0.4444rem;
         width: 100%;
         height: 0.4074rem;
         border-top: 1px solid #F3F4F9;
         border-bottom: 1px solid #F3F4F9;
     }
     .bottom-list span {
         font-size: 0.3333rem;
         font-weight: 400;
         color: #7B84A1;
         line-height: 0.4074rem;
         opacity: 0.5;
     }
     .bottom-list span:first-child{
         margin-right: 5.0185rem;
         margin-left: 1.2593rem;
     }
     .upload-btn {
         width: 100%;
         height: 1.6667rem;
         bottom: 1.25rem;
         box-sizing: border-box;
         padding: 0.3704rem 0.3333rem 0.3704rem 0.3333rem;
         background: #FFFFFF;
         font-size: 0.3333rem;
         font-weight: 700;
         color: #FFFFFF;
     }
     .check-btn {
        width: 100%;
        height: 0.9259rem;
        background: #4C70E8;
        border-radius: 0.1111rem;
        text-align: center;
        line-height: 0.9259rem;
    }
    .check-btn span {        
        font-size: 0.3333rem;
        font-weight: 400;
        color: #FFFFFF;
    }
    .check-btn span:first-child {        
        font-weight: 700;
    }
    .dot {
        position: relative;
        top: -0.0556rem;
    }
     .digNavigate {
        border-top:  1px solid #F3F4F9;
     }
 </style>